export default "__VITE_ASSET__b48a007f__"